import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpService } from '../../services/http.service';
import { Banks } from '../interfaces/banks.interface';
import { DistinctValuesResponse } from '../interfaces/distinct-values-response.interface';

@Injectable({ providedIn: 'root' })
export class MasterDataHttpService extends HttpService {
  getBankList(): Observable<Banks[]> {
    return this.http.get<Banks[]>(`${this.originatorBaseUrl}banks`, {
      headers: this.getHeaders(),
    });
  }

  getEtrDistinctFilterValues(): Observable<DistinctValuesResponse> {
    return this.http.get<DistinctValuesResponse>(
      `${this.originatorBaseUrl}etr/distinct-filter-values`,
      {
        headers: this.getHeaders(),
      },
    );
  }

  getBanksCurrencies(): Observable<string[]> {
    return this.http.get<string[]>(
      `${this.originatorBaseUrl}banks/currencies`,
      { headers: this.getHeaders() },
    );
  }

  getClassificationList(): Observable<{ id: number; value: string }[]> {
    return this.http.get<{ id: number; value: string }[]>(
      `${this.originatorBaseUrl}classification`,
      { headers: this.getHeaders() },
    );
  }
}
